"use client"

import { useState } from "react"
import { useLanguage } from "../contexts/LanguageContext"

const Contact = () => {
  const { t, language } = useLanguage()
  const contactClass = language === 'he' ? 'rtl-text' : ''

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitStatus, setSubmitStatus] = useState("idle") // idle, success, error

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setSubmitStatus('submitting')
    try {
      const response = await fetch('https://hook.eu2.make.com/qu3ms14uuzgtloxaqshwqf295pmdbycu', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      if (response.ok) {
        setSubmitStatus('success')
        setFormData({ name: "", email: "", phone: "", message: "" })
      } else {
        setSubmitStatus('error')
      }
    } catch (error) {
      console.error('Error submitting form:', error)
      setSubmitStatus('error')
    }
    setIsSubmitting(false)
  }

  return (
    <section id="contact" className={`contact ${contactClass}`} itemScope itemType="https://schema.org/ContactPage">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="contact-title" itemProp="name">{t("contactTitle")}</h2>


            <div className="contact-details">
              <a href="mailto:info@goldhouse-apart.com" className={`contact-item ${language === 'he' ? 'rtl-contact-item' : ''}`} itemProp="email">
                <div className="contact-icon">📧</div>
                <div className="contact-item-content">
                  <h4>{t("email") || "Email"}</h4>
                  <p>{t("emailClickMessage") || "Click here to send us a message"}</p>
                </div>
              </a>
              <a href="tel:+972584204297" className={`contact-item ${language === 'he' ? 'rtl-contact-item' : ''}`} itemProp="telephone">
                <div className="contact-icon">📱</div>
                <div className="contact-item-content">
                  <h4>{t("phone") || "Phone"}</h4>
                  <p>{t("phoneClickMessage") || "Click here to call us"}</p>
                </div>
              </a>
              <a href="https://wa.me/972584204297" target="_blank" rel="noopener noreferrer" className={`contact-item ${language === 'he' ? 'rtl-contact-item' : ''}`}>
                <div className="contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="#ffffff" className="whatsapp-icon">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                </div>
                <div className="contact-item-content">
                  <h4>WhatsApp</h4>
                  <p>{t("whatsappClickMessage") || "Click here to send us a message"}</p>
                </div>
              </a>
            </div>
          </div>

          <div className="contact-form-container">
            <form className={`contact-form ${language === 'he' ? 'rtl-form' : ''}`} onSubmit={handleSubmit}>
              <div className={`form-row ${language === 'he' ? 'rtl-form-row' : ''}`}>
                <div className={`form-group ${language === 'he' ? 'rtl-form-group' : ''}`}>
                  <label htmlFor="name">{t("name")}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder={t("name")}
                    className={language === 'he' ? 'rtl-input' : ''}
                  />
                </div>
                <div className={`form-group ${language === 'he' ? 'rtl-form-group' : ''}`}>
                  <label htmlFor="email">{t("email")}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder={t("email")}
                    className={language === 'he' ? 'rtl-input' : ''}
                  />
                </div>
              </div>
              <div className={`form-group ${language === 'he' ? 'rtl-form-group' : ''}`}>
                <label htmlFor="phone">{t("phone")}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder={t("phone")}
                  className={language === 'he' ? 'rtl-input' : ''}
                />
              </div>
              <div className={`form-group ${language === 'he' ? 'rtl-form-group' : ''}`}>
                <label htmlFor="message">{t("message")}</label>
                <textarea
                  id="message"
                  name="message"
                  rows="2"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder={t("message")}
                  className={language === 'he' ? 'rtl-input' : ''}
                ></textarea>
              </div>
              <button 
                type="submit" 
                className={`submit-btn ${submitStatus !== 'idle' ? submitStatus : ''} ${language === 'he' ? 'rtl-button' : ''}`} 
                disabled={isSubmitting}
              >
                {submitStatus === 'submitting' ? t("sending") : 
                 submitStatus === 'success' ? t("sent") : 
                 submitStatus === 'error' ? t("error") : 
                 t("sendMessage")}
              </button>
              {submitStatus === 'success' && <p className="form-message success">{t("messageSent")}</p>}
              {submitStatus === 'error' && <p className="form-message error">{t("messageError")}</p>}
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
